import React from 'react';
import Modal from 'react-modal';
import Iframe from 'react-iframe';

export default function IframePopup({ isOpen, title, link, onClose }) {
    return (
        <Modal
            isOpen={!!isOpen}
            contentLabel={title}
            shouldCloseOnOverlayClick={true}
            shouldCloseOnEsc={true}
            portalClassName="e-modal"
            overlayClassName="e-modal__overlay"
            className="e-modal__content"
            bodyOpenClassName="e-modal--is-open"
            htmlOpenClassName="prevent-scroll"
            shouldFocusAfterRender={false}
            ariaHideApp={false}
            onRequestClose={() => onClose()}
        >
            <Iframe url={link} display="initial" position="relative" className="iframe" frameBorder={0} />
            <div className={'e-modal__button-container'}>
                <button
                    onClick={() => onClose()}
                    type="button"
                    className="e-modal__button-close btn btn-primary btn-block"
                    aria-label="Close"
                >
                    {window.VULOG_TRANSLATE('Close')}
                </button>
            </div>
        </Modal>
    );
}
